<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
          <div class="form-group row align-items-center">
            <label for="title" class="col-sm-3 mb-0">
              {{ $t("title") }}
            </label>
            <app-input
              id="title"
              class="col-sm-9"
              type="text"
              v-model="site.title"
              :required="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="" class="col-sm-3 mb-0">
              {{ $t("description") }}
            </label>
            <app-input
              id="description"
              class="col-sm-9"
              type="textarea"
              v-model="site.description"
              :required="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="" class="col-sm-3 mb-0">
              {{ $t("assignment_structure") }}
            </label>
            <app-input
              class="col-sm-9"
              type="textarea"
              v-model="site.assignment_structure"
              :required="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="" class="col-sm-3 mb-0">
              {{ $t("site_address") }}
            </label>
            <app-input
              class="col-sm-9"
              type="textarea"
              v-model="site.site_address"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="" class="col-sm-3 mb-0">
              {{ $t("site_info") }}
            </label>
            <app-input
              class="col-sm-9"
              type="textarea"
              v-model="site.site_info"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="start_time" class="col-sm-3 mb-0">
              {{ $t("start_time") }}
            </label>
            <app-input
              id="start_time"
              class="col-sm-9"
              type="time"
              v-model="site.starting_hours"
              :required="true"
            />
          </div>
          <div class="form-group row align-items-center">
            <label for="end_time" class="col-sm-3 mb-0">
              {{ $t("end_time") }}
            </label>
            <app-input
              id="end_time"
              class="col-sm-9"
              type="time"
              v-model="site.ending_hours"
              :required="true"
            />
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../../../Helpers/AxiosHelper";
import {
  COMPANY_JOB_SITE_EDIT,
  COMPANY_JOB_SITE_UPDATE,
} from "../../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    id: Number,
    siteRefresh: Function,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      site: {},
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("edit_site"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.preloader = true;

      // this.site.id = this.id;
      

      axiosPost(COMPANY_JOB_SITE_UPDATE, this.site)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
          $("#demo-add-edit-Modal").modal("hide");
          this.preloader = false;
          this.siteRefresh();
        });
      // this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getSite() {
      axiosGet(COMPANY_JOB_SITE_EDIT + "/" + this.id)
        .then((res) => {
          this.site = res.data;
          //   this.site.start_time = this.site.starting_hours;
          //   this.site.end_time = this.site.ending_hours;
          //   this.tasks = this.site.tasks;
          // this.sites = this.job.sites;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getSite();
  },
};
</script>
